module.exports = __webpack_public_path__ + "static/img/dlb_rzs.84bcd6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dlb_rzs.png
// module id = 5LuO
// module chunks = 0